import { request } from '@/common/utils/request'
import { getBDCountry, getBDTimezone, getBDLocale } from '@/common/utils/i18n'
export const getCommonParams = function () {
  return {
    country: getBDCountry(),
    timezone: getBDTimezone(),
  }
}

export default {
  getViolationList(param) {
    return request.post({
      url: 'taxue.controlViolation.getList',
      data: {
        ...getCommonParams(),
        ...param,
        locale: getBDLocale(),
      },
    })
  },
  getViolationDetail(params) {
    return request.get({
      url: 'taxue.controlViolation.detail',
      data: {
        ...getCommonParams(),
      },
      params,
    })
  },
  getFeatureGrayStatus(params) {
    return request.get({
      url: 'feidian.common.getFeatureGrayStatus',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  getNotificationControl(params) {
    return request.post({
      url: 'feidian.common.appNotificationControl',
      data: {
        ...getCommonParams(),
        ...params,
      },
    })
  },
  getConfigList(params) {
    return request.post({
      url: 'taxue.config.getConfigList',
      data: {
        ...getCommonParams(),
        country: getBDCountry(),
        timezone: getBDTimezone(),
        locale: getBDLocale(),
        ...params,
      },
    })
  },
  addFeedInfo(params) {
    return request.post({
      url: 'taxue.controlViolation.addFeedBack',
      data: {
        ...getCommonParams(),
        ...params,
        locale: getBDLocale(),
      },
    })
  },
  setAppeal(params) {
    return request.post({
      url: 'taxue.controlViolation.appeal',
      data: {
        ...getCommonParams(),
        ...params,
        locale: getBDLocale(),
      },
    })
  },
  setResolve(params) {
    return request.post({
      url: 'taxue.controlViolation.resolveRectificationProcess',
      data: {
        ...getCommonParams(),
        ...params,
        locale: getBDLocale(),
      },
    })
  },
}
